import { render, staticRenderFns } from "./svgGoogleplay.vue?vue&type=template&id=029a55ca"
import script from "./svgGoogleplay.vue?vue&type=script&lang=js"
export * from "./svgGoogleplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports